/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ time: NonNullable<unknown> }} Agent_Approvals_Waiting_SinceInputs */



/**
* | output |
* | --- |
* | "Waiting since {time}" |
*
* @param {Agent_Approvals_Waiting_SinceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_approvals_waiting_since = /** @type {((inputs: Agent_Approvals_Waiting_SinceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Approvals_Waiting_SinceInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Wartet seit ${i?.time}`)
	return /** @type {LocalizedString} */ (`Waiting since ${i?.time}`)
});